import { Link, Outlet, useNavigate } from "react-router-dom";
import { CircularLoader } from "./CircularLoading";
import { useTranslation } from "react-i18next";
import { ClientContext, ClientContextType } from "../storage/ClientStorage";
import { getToken } from "../services/utils/store";
import { use, useContext, useEffect, useState } from "react";
import { Account } from "./Account";
import { Logger } from "html2canvas-pro/dist/types/core/logger";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

export default function LayoutHeaderUser() {
  const [menuActive, setMenuActive] = useState(false);
  const toggleMenu = () => setMenuActive((prev) => !prev);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state, dispatch } = useContext<ClientContextType>(ClientContext);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      navigate("/login");
      return;
    }
  }, []);

  if (loading) {
    return (
      <div className="flex p-5 md:p-8 w-full h-full justify-center items-center overflow-scroll">
        <div className={"block mx-auto"}>
          <CircularLoader size={100} />
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen w-screen flex flex-col justify-between">
      <div className="flex flex-col flex-grow bg-gray-50">
        <div className="flex flex-row items-center justify-between bg-[#22398E] border-b w-full h-14 md:h-16 px-3 md:px-4">
          <Logo classImg="h-12 w-auto md:h-14 object-contain" />
          <div className="flex items-center gap-4">
            <Account />
          </div>
        </div>
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}
